/**
 * icon-story-spring.js
 * Critically-damped spring for House of Parvi icon story interactions.
 * Usage: HOP.spring(element, property, target, options)
 */
(function() {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.HOP = window.HOP || {};
    window.HOP.spring = function(el, prop, target) {
      el.style[prop] = target + (prop === 'opacity' ? '' : 'px');
    };
    return;
  }

  var active = new Map();

  function springStep(current, target, velocity, stiffness, damping, dt) {
    var displacement = current - target;
    var springForce = -stiffness * displacement;
    var dampingForce = -damping * velocity;
    var acceleration = springForce + dampingForce;
    var newVelocity = velocity + acceleration * dt;
    var newPosition = current + newVelocity * dt;
    return { value: newPosition, velocity: newVelocity };
  }

  function animate(el, prop, target, opts) {
    var key = el.dataset.hopSpringId + '-' + prop;
    if (active.has(key)) {
      var prev = active.get(key);
      prev.target = target;
      return;
    }

    if (!el.dataset.hopSpringId) {
      el.dataset.hopSpringId = 'sp-' + Math.random().toString(36).substr(2, 6);
      key = el.dataset.hopSpringId + '-' + prop;
    }

    var stiffness = (opts && opts.stiffness) || 180;
    var damping = (opts && opts.damping) || 26;
    var unit = (opts && opts.unit) || (prop === 'opacity' ? '' : 'px');
    var threshold = (opts && opts.threshold) || 0.5;
    var velocityThreshold = (opts && opts.velocityThreshold) || 0.01;

    var current = parseFloat(el.style[prop]) || (opts && opts.from !== undefined ? opts.from : 0);
    var velocity = 0;
    var state = { target: target };
    active.set(key, state);

    var lastTime = null;
    function tick(now) {
      if (!lastTime) { lastTime = now; }
      var dt = Math.min((now - lastTime) / 1000, 0.064); // cap at ~15fps min
      lastTime = now;

      var result = springStep(current, state.target, velocity, stiffness, damping, dt);
      current = result.value;
      velocity = result.velocity;

      el.style[prop] = current + unit;

      if (Math.abs(current - state.target) < threshold && Math.abs(velocity) < velocityThreshold) {
        el.style[prop] = state.target + unit;
        active.delete(key);
        if (opts && opts.onComplete) opts.onComplete();
        return;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  window.HOP = window.HOP || {};
  window.HOP.spring = animate;
})();
